var _path, _rect, _rect2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProductMinus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.1291V16.1291L9.57143 20.0001M1 6.1291L9.57143 9.67748M1 6.1291L9.57143 1.93555L18.4603 6.1291M9.57143 20.0001L18.4603 16.1291V6.1291M9.57143 20.0001V9.67748M18.4603 6.1291L9.57143 9.67748",
    stroke: "#FF705D",
    strokeWidth: 1.26984
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.0881,
    y: 2.43384,
    width: 6.93359,
    height: 7.03145,
    rx: 3.4668,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0881,
    y: 2.43384,
    width: 6.93359,
    height: 7.03145,
    rx: 3.4668,
    stroke: "#FF705D",
    strokeWidth: 0.866699
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2084 6.60463H16.1251H14.5V5.50378L16.1251 5.50384L17.2084 5.50378H18.8335V6.60463H17.2084Z",
    fill: "#FF705D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductMinus);
export default __webpack_public_path__ + "static/media/icon-product-minus.3a5fcb98d5ae9a9a3780814535c16276.svg";
export { ForwardRef as ReactComponent };